import { Injectable, } from '@angular/core';
import { Resolve } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { PostsApiService } from '../api/posts.service';

@Injectable({ providedIn: 'root' })
export class DataResolver implements Resolve<any> {
  constructor(
    private apiService: PostsApiService,
  ) { }

  resolve(): Observable<any> {
    const postData$ = this.apiService.getPosts('today', 1, 'none');
    const announcementData$ = this.apiService.getAnnouncement();

    return forkJoin({
      posts: postData$,
      announcement: announcementData$,
    });

    // return this.apiService.getPosts('today', 1, 'none')
  }
}
